module.exports = __webpack_public_path__ + "static/img/erer.42e7c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erer.png
// module id = QvbD
// module chunks = 0